export enum BeneficiaryDefinition {
    REGULAR = 1, // רגיל
    IRREVOCABLE = 2 // בלתי חוזר
  }
  export enum BeneficiaryType {
    LIFE_BENEFICIARY = 1, // מוטב למקרה חיים
    DEATH_BENEFICIARY = 2 // מוטב למקרה מוות
  }

  export enum BeneficiaryIdentificationType {
    INDIVIDUAL = 1, // פרטי
    CORPORATION = 2, // תאגיד
    LEGAL_HEIRS = 3, // יורשים חוקיים
    WILL = 4, // צוואה
    SURVIVOR = 5, // שאיר
    OTHER = 6, // אחר
    NOT_SPECIFIED = 7 // לא נקבעו מוטבים ע"י הלקוח
  }

  export enum BeneficiaryIDCode {
    ID_NUMBER = 1, // מספר תעודת זהות
    PASSPORT = 2, // מספר דרכון
    OTHER = 3 // אחר
  }
  export enum YesNo {
    YES = 1, // כן
    NO = 2, // לא
  }
  export enum CoveragePayerType {
    EMPLOYER = 1, // מעסיק
    EMPLOYEE = 2, // עובד
    EMPLOYER_WITH_SALARY_PERCENTAGE_CAP = 3, // מעסיק עם תקרה של אחוז מהשכר
    EMPLOYER_WITH_CAP_AND_EMPLOYEE_COVERAGE = 4, // מעסיק עם תקרה של אחוז מהשכר והיתרה ע"ח העובד
    EMPLOYER_WITH_CAP_AND_CONTRIBUTIONS_COVERAGE = 5, // מעסיק עם תקרה של אחוז מהשכר והיתרה ע"ח הפרשות
    FROM_CONTRIBUTIONS = 6, // מתוך ההפרשות
  }
  export enum UnderwritingType {
  MEDICAL = 1, // רפואי
  PROFESSIONAL_OR_HOBBY = 2, // מקצועי או תחביב
  UNASSIGNED = 3, // לא משויך
}
  export enum InsuranceType {
    DEATH = 1, // כיסוי למקרה מוות
    OCCUPATIONAL_DISABILITY = 2, // נכות מקצועית
    ACCIDENTAL_DEATH = 3, // מוות מתאונה
    ACCIDENTAL_DISABILITY = 4, // נכות מתאונה
    LOSS_OF_WORK_CAPACITY = 5, // אובדן כושר עבודה
    PREMIUM_WAIVER = 6, // שחרור מתשלום פרמיות
    CRITICAL_ILLNESS = 7, // מחלות קשות
    COMBINED_SAVINGS_PLAN = 8, // תוכנית משולבת חיסכון
    DEATH_AND_DISABILITY = 9, // מוות + אכ"ע
    OTHER = 10, // אחר
  }
  export enum InsuredType {
    PRIMARY = 1, // ראשי
    SECONDARY = 2, // משני
    CHILD = 3, // ילד
    MUTUAL = 4, // הדדי
    OTHER = 5, // אחר
  }
  
  export enum OccupationType {
    ANY_OCCUPATION = 1, // כל עיסוק
    REASONABLE_OTHER_OCCUPATION = 2, // עיסוק סביר אחר
    SPECIFIC_OCCUPATION = 3, // עיסוק ספציפי
  }

  export enum FixedOrVariableSum {
    FIXED = 1, // קבוע
    VARIABLE = 2, // משתנה
  }
  export enum PayoutMethod {
    LUMP_SUM = 1, // סכום ח"פ
    PENSION = 2, // קצבה
    PERIODIC_PAYMENTS = 3, // תשלומים תקופתיים
    OTHER = 4, // אחר
    CAPITAL_AND_PENSION = 5, // הון+קצבה
  }
  export enum WaitingPeriod {
    MONTHS_24 = 1, // 24 חודשים
    MONTHS_36 = 2, // 36 חודשים
    MONTHS_48 = 3, // 48 חודשים
    MONTHS_60 = 4, // 60 חודשים
    FULL_PERIOD = 5, // לכל התקופה
  }
  export enum DisabilityRisk {
    ONE_PERCENT = 1, // 1%
    TWO_PERCENT = 2, // 2%
    NO = 3, // לא
  }
  export enum InsuranceSumRate {
  AMOUNT = 1, // סכום ביטוח
  RATE = 2, // שיעור ביטוח
}
export enum DiscountType {
  FORCED_COST = 1, // עלות כפויה
  PERCENTAGE = 2, // הנחת באחוזים
  AMOUNT = 3, // הנחת סכום
  PROMILLE = 4, // פרומיל
  OTHER = 5, // אחר
}
export enum DiscountTerms {
  FULL_PERIOD = 1, // הנחה לכל תקופת הביטוח
  FIXED_TERM = 2, // הנחה לתקופה קצובה
  EMPLOYER_TERM = 3, // הנחה למשך תקופת העבודה אצל המעסיק
  NONE = 4, // לא ניתנה הנחה
  FIXED_EMPLOYER = 5, // הנחה לתקופה קצובה המותנית במעסיק ספציפי
}
export enum CoverageTypeAtManufacturer {
  BASIC_INSURANCE = 1, // ביטוח יסודי
  RIDER = 2, // נספח (ריידר)
}
export interface InsuranceFees {
  insurance_percentage?: number; // ACHUZ-ME-SCM-BTH-YESODI
  salary_percentage?: number; // ACHUZ-MESACHAR
 
 
  fee?: number; // DMEI-BITUAH-LETASHLUM-BAPOAL
  discount?: number; // HANACHA
  insurance_discount_type?: number; // SUG-HANACHA-KISUY  DiscountType
  discount_percentage?: number; // SHIUR-HANACHA-BEKISUI
  discount_value?: number; // ERECH-HANACHA-BEKISUI
  tiered_discount?: number; // HANACHA-MEDUREGET
  discount_terms?: number; // TNAEI-HANACHA DiscountTerms
  discount_end_date?: string; // MOED-SIUM-TKUFAT-HANACHA
  insurance_sum_rate?: number; // SCHUM_SHEUR  InsuranceSumRate
  fixed_or_variable_sum?: number; // SCHUM-BITUH-KAVOA-MISHTANE
  fixed_or_variable_rate?: number; // SHEUR-BITUH-KAVOA-MISHTANE
  premium_change_rate?: number; // TADIRUT-SHINUY-DMEI-HABITUAH-BESHANIM
  payment_stop_date?: string; // TAARICH-HAFSAKAT-TASHLUM
  next_update_date?: string; // TAARICH-IDKUN-HABA-SHEL-DMEI-HABITUAH
}

export interface CoverageDetails {
  coverage_code?: string; // KOD-MIUTZAR-LAKISUY 
  payout_method?: number; // OFEN-TASHLUM-SCHUM-BITUACH  # PayoutMethod
  insurance_sum?: number; // SCHUM-BITUACH
  insured_type: number; // SUG-MEVUTACH (InsuredType)
  insurance_kind: number; // SUG-KISUY-BITOCHI (InsuranceType)
  start_date?: string; // TAARICH-TCHILAT-KISUY
  end_date?: string; // TAARICH-TOM-KISUY
  coverage_attachment_code: string; // KOD-NISPACH-KISUY
  occupation_type: number; // SUG-ISUK
  includes_prenzisa: number; // KOLEL-PRENZISA
  includes_nursing: number; // KOLEL-SIUD
  waiting_period: number; // KITZBA-ZMUDA-LAMADAD
  disability_risk: number; // NACHUT-MITPATAHAT
  government_deduction_cancellation: number; // BITUL-KIZUZ-MEMSHALTI
  coverage_payer: number; // MESHALEM-HAKISUY  CoveragePayerType
  approval_code: number; // KOD-ISHUN
  signed: number; // IND-CHITUM
  signing_date?: string; // TAARICH-CHITUM
  underwriting: number; // HACHRAGA
  underwriting_type: number; // SUG-HACHRAGA  UnderwritingType
  qualification_period: number; // TKUFAT-ACHSHARA
  waiting_period_months: number; // TKUFAT-HAMTANA-CHODASHIM  WaitingPeriod 
  cap_ceiling: number; // TIKRAT-GAG-HATAM-LE-O-K-A
  cap_increase_percentage: number; // ACHUZ-HAGDALAT-GAG-HATAM-O-K-A
  insurance_fees?: InsuranceFees; // מבנה מבודד לשדות תשלום
  [key: string]: any;
}

  
  export interface PensionFundCoverage {
    disability_coverage_cost?: number; // עלות כיסוי נכות בש"ח
    disabled_survivor_pension_cost?: number; // עלות כיסוי פנסיית שארים של נכה בש"ח
    disability_coverage_rate?: number; // שיעור כיסוי נכות במסלול ביטוח
    defining_salary?: number; // שכר קובע לכיסוי נכות ושאירים
    salary_relevant_date?: string; // תאריך נכונות שכר קובע לכיסוי נכות ושאירים
    survivors_waiver_type?: number; // Enum: SurvivorsWaiverType | סוג ויתור שארים
    total_disability_pension?: number; // סך פנסיית נכות בש"ח
    developing_disability?: number; // Enum: DevelopingDisability | נכות מתפתחת
    insurance_waiver?: number; // Enum: InsuranceWaiver | ויתור על כיסוי ביטוחי לנכות (מעל גיל 60)
    survivors_coverage_cost?: number; // עלות כיסוי שארים בש"ח
    orphan_coverage_rate?: number; // שיעור כיסוי ביטוחי ליתום של עמית פעיל במסלול ביטוח
    widow_pension_amount?: number; // קצבת שארים לאלמן/ת עמית פעיל לפי מסלול ביטוח
    orphan_pension_amount?: number; // קצבת שארים ליתום של עמית פעיל לפי מסלול ביטוח
    parent_support_pension_amount?: number; // קצבת שארים להורה נתמך של עמית פעיל לפי מסלול ביטוח
    waiver_signature_date?: string; // תאריך חתימה על ויתור שארים
    waiver_end_date?: string; // תאריך סיום ויתור שארים
    widow_coverage_rate?: number; // שיעור כיסוי ביטוחי לאלמן/ת עמית פעיל במסלול ביטוח
    parent_support_coverage_rate?: number; // שיעור כיסוי ביטוחי להורה נתמך של עמית פעיל
    retirement_age?: number; // גיל פרישה לפנסיית זקנה לפי מסלול ביטוח
   
    consecutive_membership_months?: number; // מספר חודשי חברות רצופים בקרן הפנסיה
    cumulative_membership_months?: number; // מספר חודשי חברות מצטבר בקרן פנסיה ותיקה
    pension_unit?: number; // מנת פנסיה צבורה
    pension_percentage?: number; // אחוז פנסיה צבורה
    membership_start_date?: string; // תאריך תחילת חברות
    data_relevant_date?: string; // תאריך ערך לנתונים
    insurance_benefit?: number; // Enum: InsuranceBenefit | האם קיימת הטבה ביטוחית
  }
  
  export interface OccupationInfo {
    occupation_description?: string; // תיאור העיסוק (TACHVIVIM-O-ISUKIM)
    occupation_code?: string; // קוד המקצוע (KOD-MIKTZOA)
    new_occupation_field?: string; // תחום עיסוק חדש (TCHUM-ISUK-CHADASH)
  }
  export interface PremiumPeriodInfo {
    start_period?: string; // תאריך תחילת התקופה (TCHILAT-TKUFA) בפורמט YYYYMM
    end_period?: string; // תאריך סיום התקופה (TOM-TKUFA) בפורמט YYYYMM
    premium_amount?: number; // פרמיה צפויה (PREMIA-ZFOYA), ערך נומרי >= 0
  }
  export interface PensionDiscountInfo {
    start_period?: string; // תאריך תחילת התקופה (TCHILAT-TKUFA) בפורמט YYYYMM
    end_period?: string; // תאריך סיום התקופה (TOM-TKUFA) בפורמט YYYYMM
    discount_percentage?: number; // שיעור הנחה (SHEUR-HANACHA) ערך באחוזים
    discount_amount?: number; // סכום הנחה (SCHUM-HANACHA) במונחים חודשיים (≥ 0)
  }
  
    
  
  export interface InsuranceCoverageInfo {
    start_period?: string; // תאריך תחילת התקופה (TCHILAT-TKUFA) בפורמט YYYYMM
    end_period?: string; // תאריך סיום התקופה (TOM-TKUFA) בפורמט YYYYMM
    insurance_percentage?: number; // שיעור ביטוח צפוי (SHEUR-BITUH-ZFOY) ערך באחוזים
    insurance_amount?: number; // סכום ביטוח צפוי (SCHUM-BITUH-ZFOY) במונחים שנתיים (≥ 0)
  }
  export enum AdditionalTypeEnum {
    MEDICAL_PERCENTAGE = 1, // תוספת רפואית באחוזים
    MEDICAL_PROMIL = 2, // תוספת רפואית בפרומיל
    PROFESSIONAL_HOBBY_PERCENTAGE = 3, // תוספת מקצועית / תחביב באחוזים
    PROFESSIONAL_HOBBY_PROMIL = 4, // תוספת מקצועית / תחביב בפרומיל
    MEDICAL_AMOUNT = 5, // תוספת רפואית בסכום
    PROFESSIONAL_HOBBY_AMOUNT = 6 // תוספת מקצועית / תחביב בסכום
  }
  
  export interface AdditionalDetails {
    additional_tariff: number; // TOSEFET-TAARIF (AdditionalTariffEnum)
    additional_type: number; // KOD-SUG-TOSEFET (AdditionalTypeEnum)
    additional_rate: number; // SHEUR-TOSEFET
    additional_promil: number; // PROMIL-TOSEFET
    additional_end_date?: string; // TAARICH-TOM-TOSEFET
  }
  export enum InsurancePaymentFrequency {
    SEMI_ANNUAL = 1, // חצי שנתי
    MONTHLY = 2, // חודשי
    ADJUSTED = 3, // מתואם
    NON_INDEXED = 4, // לא צמוד
    INDEXED_PROFITS = 5, // רווחי הצמדה
    PROFIT_PARTICIPATION = 6, // משתתף ברווחים
    USD = 7, // דולר
    LIBOR_INDEXED = 8, // צמוד למדד הליבור
    NON_USD_FOREIGN_CURRENCY_INDEXED = 9 // צמוד למט"ח לא דולרי
  }
  export enum InsurancePlanType {
    BASIC = 0, // יסודי
    REQUESTED_INSURANCE_SUM = 1, // סכום ביטוח מבוקש
    SALARY_MULTIPLES = 2, // כפולות שכר
    SAVINGS_ALLOCATION_PERCENTAGE = 3, // אחוז הקצאה לחסכון
    PURE_SAVINGS = 4 // חסכון טהור
  }
  export interface BasicInsuranceDetails {
    product_code: string; // KOD-MUTZAR-LEFI-KIDUD-ACHID-LAYESODI
    insurance_amount: number; // SCHUM-BITUAH-LEMAVET
    adjustment_type: number; // SUG-HATZMADA-SCHUM-BITUAH ENUM:InsurancePaymentFrequency 
    insurance_plan_type: number; // SUG-MASLUL-LEBITUAH ENUM:InsurancePlanType
    includes_savings: number; // IND-SCHUM-BITUAH-KOLEL-CHISACHON
    requested_insurance_amount: number; // SCHUM-BITUACH-LEMASLUL
    salary_multiples: number; // MISPAR-MASKOROT
    savings_allocation: number; // ACHUZ-HAKTZAA-LE-CHISACHON
    death_cap_ceiling: number; // TIKRAT-GAG-HATAM-LEMIKRE-MAVET
    disability_cap_ceiling: number; // TIKRAT-GAG-HATAM-LE-O-K-A
    cap_increase_percentage: number; // ACHUZ-HAGDALAT-GAG-HATAM
  }
  
  
  export interface InsuredDetails {
    id_type: number; // SUG-TEUDA
    id_number: string; // MISPAR-ZIHUY-LAKOACH
  }
  

  export interface BeneficiaryInfo {
    identification_type: number; // סוג זיהוי מוטב (SUG-ZIHUY-MUTAV) Enum: BeneficiaryIdentificationType
    id_code: number; // קוד זיהוי מוטב (KOD-ZIHUY-MUTAV) Enum: BeneficiaryIDCode
    id_number?: string; // מספר זיהוי מוטב (MISPAR-ZIHUY-MUTAV)
    first_name?: string; // שם פרטי מוטב (SHEM-PRATI-MUTAV)
    last_name?: string; // שם משפחה מוטב (SHEM-MISHPACHA-MUTAV)
    birth_date?: string; // תאריך לידה מוטב (TAARICH-LEIDA-MUTAV)
    relation_type?: number; // סוג זיקה (SUG-ZIKA) Enum: RelationType
    beneficiary_percentage?: number; // אחוז מוטב (ACHUZ-MUTAV)
    definition?: number; // הגדרת מוטב (HAGDARAT-MUTAV) Enum: BeneficiaryDefinition
    beneficiary_nature?: number; // מהות מוטב (MAHUT-MUTAV) Enum: BeneficiaryType
  }
  
  export interface InsuranceCoverage {
    coverage_name: string; // kisui.get('SHEM-KISUI-YATZRAN' ,'')
    coverage_number: string; // kisui.get('MISPAR-KISUI-BE-YATZRAN' ,'')
    coverage_type_at_manufacturer?: number; // SUG-KISUI-ETZEL-YATZRAN - Enum: CoverageTypeAtManufacturer
    coverage_details?: CoverageDetails;
    coverages: PensionFundCoverage[]; // KisuiBKerenPensia
    beneficiaries: BeneficiaryInfo[]; // Mutav
    occupation_info: OccupationInfo[]; // Miktsoa-Isuk-Tachviv
    premium_period: PremiumPeriodInfo[]; // hitpatchutpremia
    insurance_discount: PensionDiscountInfo[]; // hitpatchutschusheurmbituh
    insurance_coverage: InsuranceCoverageInfo[]; // hitpatchutschusheurmbituh
    additional_details: AdditionalDetails[]; // kisui.get('PirteiTosafot', [])
    basic_insurance: BasicInsuranceDetails[]; // kisui.get('SchumeiBituahYesodi', '')
    insured_details: InsuredDetails[]; // kisui.get('PirteiMevutach' , [])
    other_policy_number: string; // kisui.get('MISPAR-POLISA-O-HESHBON-NEGDI'  , [])
  }
  